import template from './wizard_companies.html';

class WizardCompaniesViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	};

	next_wizard()
	{
		Grape.dialog.open('WizardDepartmentsEntry', {});
		this.dialog.close();
	};
};

class WizardCompaniesPage
{
	constructor (bindings)
	{
		this.viewModel = new WizardCompaniesViewModel(this);
		this.bindings = bindings;
	};
};

export default {
	name: 'WizardCompaniesEntry',
	dialog_class: WizardCompaniesPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_companies',
	provider: 'ps'
};
